import { QueryFunctionContext } from "react-query";
import { useAuthStore } from "../store";
import idServerApi from "./idServerApi";
import { decodeAuthToken, checkTokenValidity } from "../components/utils";

export async function checkHeartBeat() {
  return idServerApi
    .get("auth/heartbeat")
    .then((res: any) => {
      const userId = res.data.data;
      if (userId) {
        const user = useAuthStore.getState().accessToken;
        const userPayload = decodeAuthToken(user!);
        if (userId.toString() !== userPayload.id.toString()) {
          sessionStorage.clear();
          useAuthStore.getState().clear();
          window.location.reload();
        }
      }
      //Check if token will expire within 1 minute
      if (!checkTokenValidity(65000)) {
        refetchAccessToken().then((newToken) => {
          const userPayload = decodeAuthToken(newToken);
          if (userId.toString() === userPayload.id.toString()) {
            useAuthStore.getState().setAuth((state) => ({
              ...state,
              accessToken: newToken,
            }));
          }
        });
      }
      return userId;
    })
    .catch((err: any) => {
      if (
        err?.response?.data?.status === 403 ||
        err?.response?.data?.status === 401
      ) {
        sessionStorage.clear();
        useAuthStore.getState().clear();
        const redirectUrl = generateRedirectUrl();
        if (window.location.hostname !== "localhost")
          window.location.href = redirectUrl;
      }
    });
}

export async function refetchAccessToken(): Promise<string> {
  return idServerApi
    .get("auth/token")
    .then((res: any) => res.data.data)
    .catch((err: any) => {
      if (err?.response?.data?.status === 403) {
        const redirectUrl = generateRedirectUrl();
        if (window.location.hostname !== "localhost")
          window.location.href = redirectUrl;
      }
    });
}

export async function signOut(
  data: any
): Promise<{ message: string; data: string }> {
  return idServerApi
    .post(`auth/logout`, undefined)
    .then((res: any) => res.data);
}

export async function getPlatformInfo(
  context: QueryFunctionContext
): Promise<any> {
  const accesstoken = context.queryKey[1] as string;
  return idServerApi
    .get(`auth/user/platform`, {
      headers: {
        accesstoken,
      },
    })
    .then((res: any) => res.data.data);
}

export function generateRedirectUrl() {
  const redirectUrl = encodeURIComponent(window.location.href);
  const baseUrl = (
    process.env.REACT_APP_ID_SERVER_CLIENT_URL ??
    "https://identity.dev.hissa.com"
  ).replace(/\/+$/, "");
  const url = `${baseUrl}/login?redirect=${redirectUrl}&platform=esop`;
  return url;
}
